import React from "react";
import { Typography } from "@material-ui/core";
import DataTable from "Components/Shared/DataTable/DataTable";
import DataTableRow from "Components/Shared/DataTable/DataTableRow/DataTableRow";
import pretty from "Shared/pretty";

export interface FileDetailsTableProps {
  filename: string;
  createdAt: string
}

export const FileDetailsTable = ({ filename, createdAt }: FileDetailsTableProps) => {
  return (
    <DataTable title="File Details">
      <DataTableRow>
        <Typography>File name</Typography>
        <Typography>{filename}</Typography>
      </DataTableRow>
      <DataTableRow>
        <Typography>Uploaded on</Typography>
        <Typography>{pretty.date(
          createdAt,
          { withTime: true, format: "MM/DD/YY h:mm:ss A" }
        )}</Typography>
      </DataTableRow>
    </DataTable>
  );
};
